import { css, useTheme } from "@emotion/react";

import { useThemeProps, Button } from "../../wsui/base";

export default function PostsModuleArchiveLink(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "MunicipioPostsModuleArchiveLink" });
  let {
    label,
    uri,
    variant = "primary",
    align = "flex-start",
    ...restProps
  } = props;
  return (
    <div
      css={css`
        display: flex;
        flex-flow: column;
        align-items: ${align};
      `}
    >
      <Button variant={variant} uri={uri} {...restProps}>
        {label}
      </Button>
    </div>
  );
}
